import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { useModalityChangeCounterStore } from '@aibees/elephant/store/modality-change-counter';
import { useWorkspace } from '@aibees/shared/workspace';
import type { PeopleTableInfo } from '../types';
import {
  useBrowsePeopleSearchCore,
  type BrowsePeopleSearchDeps,
} from './use-browse-people-search';

/**
 * Table-specific wrapper for the advance-table `browseApi` config.
 *
 * Reads only lightweight deps (workspace, type, modalityVersion) from
 * hooks/context. Does NOT subscribe to `useSearchQueryFilter` —
 * the search params arrive through the `params` argument provided by
 * `useBrowseApiDataCore`, which already debounces them.
 */
export function useBrowsePeopleSearchForTable(params: Record<string, any>) {
  const workspace = useWorkspace()?.id;
  const type = useSearchTypeFromRoute();
  const { counter: modalityVersion } = useModalityChangeCounterStore();

  const { page, size, sort, ...searchParams } = params;

  const deps: BrowsePeopleSearchDeps = {
    workspace,
    type,
    searchParams,
    modalityVersion,
  };

  return useBrowsePeopleSearchCore<PeopleTableInfo>(
    { page: page || 0, size: size || 25, sort },
    deps
  );
}
